<template>
  <login-stage>
    <template slot="login-stage">
      <div class="user-authentication">
        <form @submit.prevent="signIn" class="form-template">
          <b-field
            :label="labelRegister"
            :type="{ 'is-danger': errors.has('register') }"
            :message="errors.first('register')"
          >
            <b-input
              v-model.lazy="register"
              name="register"
              v-validate="'required'"
              :data-vv-as="$t('fields_validator.register')"
              :placeholder="commonPlaceholder"
            />
          </b-field>
          <div class="link-reset">
            <router-link tag="a" :to="{ name: 'RecuperarRegistro' }">
              {{ $t('login.recovery_register') }}
            </router-link>
          </div>
          <b-field
            :label="labelPassword"
            :type="{ 'is-danger': errors.has('password') }"
            :message="errors.first('password')"
            class="password-field"
          >
            <b-input
              v-model.lazy="password"
              name="password"
              v-validate="'required'"
              type="password"
              :placeholder="commonPlaceholder"
              :data-vv-as="$t('fields_validator.password')"
              password-reveal
            />
          </b-field>
          <div class="link-reset">
            <router-link tag="a" :to="{ name: 'RecuperarSenha' }">
              {{ $t('login.recovery_password') }}
            </router-link>
          </div>
          <div class="link-reset">
            <router-link
              tag="a"
              :to="{
                name: 'RecuperarSenha',
                query: { primeiroAcesso: 'true' }
              }"
            >
              {{ $t('login.nao_tenho_senha') }}
            </router-link>
          </div>
          <invalid-auth v-if="feedback" :mensagem="mensagemfeedback" />
          <div class="field">
            <button
              :disabled="!disabledButton"
              class="button button-primary"
              type="submit"
            >
              {{ $t('login.submit_button') }}
            </button>
          </div>
        </form>
        <b-loading :is-full-page="true" :active.sync="isLoading" />
      </div>
    </template>
  </login-stage>
</template>

<script>
import LoginStage from '@/components/login/LoginStage'
import InvalidAuth from '@/components/login/InvalidAuth'
import uikit from '@/components/shared/uikit/uikit'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import router from '@/router'
import { SET_LOADING, SET_FEEDBACK_AUTH } from '@/store/modules/mutation-types'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { UserBlockedError } from '../../models/user-blocked-error'

export default {
  name: 'UserAuthentication',

  components: {
    LoginStage,
    InvalidAuth,
    ...uikit
  },

  data() {
    return {
      labelRegister: this.$t('login.label-register'),
      labelPassword: this.$t('login.label-password'),
      mandatory: this.$t('login.mandatory'),
      register: '',
      password: '',
      commonPlaceholder: this.$t('placeholders.common'),
      mensagemfeedback: this.$t('login.error')
    }
  },

  computed: {
    disabledButton() {
      return this.register && this.password
    },
    ...mapGetters({
      agendamentos: 'proximosAgendamentos',
      feedback: 'feedbackAuth',
      isLoading: 'loadingAuth',
      perfis: 'perfis'
    })
  },

  methods: {
    ...mapActions([
      'auth',
      'getPerfis',
      'getPaciente',
      'getRacaCor',
      'getEtnias',
      'getAceite',
      'getProximosAgendamentos'
    ]),
    ...mapMutations([SET_LOADING, SET_FEEDBACK_AUTH]),
    signIn() {
      this.SET_LOADING(true)
      this.SET_FEEDBACK_AUTH(false)
      this.auth({
        username: this.register,
        password: this.password
      })
        .then(() => {
          return this.getPerfis()
        })
        .then(() => {
          this.SET_LOADING(false)
          this.getRacaCor()
          this.getEtnias()
          this.direcionarUsuario()
          this.getAceite()
        })
        .catch((err) => {
          this.SET_LOADING(false)

          if (err instanceof NotAuthenticatedError) {
            this.mensagemfeedback = this.$t('login.error')
          } else if (err instanceof UserBlockedError) {
            this.mensagemfeedback = this.$t('login.usuario-bloqueado')
          } else {
            this.mensagemfeedback = this.$t('login.erro-tente-novamente')
          }
          this.SET_FEEDBACK_AUTH(true)
        })
    },
    direcionarUsuario() {
      let path = '/inicio'
      let query = {}
      if (this.perfis.length > 0) {
        if (this.perfis.length === 1) {
          this.selecionarPerfil(this.perfis[0].Prontuario).then(() => {
            this.getProximosAgendamentos(
              process.env.VUE_APP_QUANTIDADE_ITENS
            ).then(() => {
              if (
                this.agendamentos != null &&
                this.agendamentos.some((a) => a.DataRespostaPaciente == null)
              ) {
                router.push({ path: '/agenda', query: {} })
              } else {
                if (this.$route.query.returnUrl) {
                  path = this.$route.query.returnUrl
                }
                router.push({ path: path, query: query })
              }
            })
          })
        } else {
          path = '/selecionar-paciente'
          if (this.$route.query.returnUrl) {
            query = { returnUrl: this.$route.query.returnUrl }
          }
          router.push({ path: path, query: query })
        }
      }
    },
    async selecionarPerfil(codigoUsuario) {
      this.SET_LOADING(true)
      await this.getPaciente(codigoUsuario).then(() => {
        this.SET_LOADING(false)
      })
    }
  },
  beforeMount: function () {
    this.getPerfis().then(() => {
      this.direcionarUsuario()
    })
  }
}
</script>

<style lang="scss">
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/buttons';

.user-authentication {
  position: relative;
  top: 1.875rem;

  h1 {
    margin: 0 0 1.25rem;
  }

  .password-field {
    margin-top: 2.3125rem;
  }

  .password-field {
    margin-top: 1.875rem;
  }
}
.b-tabs .tabs ul li.is-active a,
.b-tabs .tabs ul li:hover a {
  color: var(--secondary);
  color: var(--secondary);
  border-bottom: 1.84px solid $secondary;
  border-color: var(--secondary);
  font-weight: bold;
}
//Responsive Mode
@media (max-width: 768px) {
  .user-authentication .link-reset-password {
    text-align: left;
  }

  .button[type='submit'].button-primary {
    display: block;
    max-width: 100%;
    text-align: center;
  }
}
</style>
